import { Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StatePersistService } from '../core/services/state-persist.service';
import { CartService } from './services/cart.service';
import { AlertService } from '../core/services/alert.service';
import { Title } from '@angular/platform-browser';
import { CartModuleConsts } from './contants';
import { GoogleAnalyticsService } from '../shared/services/google-analytics.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SharedConsts } from '../shared/constants';
import { LoaderService } from '../shared/loader/loader.service';

declare let Frames: any;
@Component({
    selector: 'cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss', '../product/product.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CartComponent implements OnInit {
  firstHit: any = 1;
  global_data:any = {};
  orderDetail: any;
  componentLoaded = false;
  allProductCounts: any;
  promotionMessage = [];
  show = false;
  bsModalRef: BsModalRef;
  pOForm: FormGroup;
  checkoutDetailsApiSubscribe:any;
  mobileListCountStorageSubscribe:any;
  hasMobileCountAlreadyCall = false;
  hasAlreadyCheckoutCall = false;
  submitted = false;
  popupMessage = '';
  commonBottonText: any = 'Ok';
  onholdMessage = CartModuleConsts.ONHOLD_MESSAGE;
  onholdMessageWithDepot = CartModuleConsts.ONHOLD_MESSAGE_WITH_DEPOT
  public  checkIfAllDataLoaded:boolean=false;
  constructor(private router: Router, private route: ActivatedRoute,
    private titleService: Title,
    private modalService: BsModalService,
    private statePersist: StatePersistService,
    private cartService: CartService,
    private alertService: AlertService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private loaderService:LoaderService,
    private formBuilder: FormBuilder) {
    const body = document.getElementsByTagName('body')[0];
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(res => {
      if (this.router.url == "/mycart") {
        body.classList.add('adjust-logo','remove-footer-accordion');
      }
      else {
        body.classList.remove('adjust-logo','remove-footer-accordion');
      }
    });
  }

  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  ngOnInit(): void { 
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    let payButton: any;
    this.titleService.setTitle(CartModuleConsts.CART_PAGE_TITLE);
    this.pOForm = this.formBuilder.group({
      po_number: ['', [Validators.required]]      
    });
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
    })
    

    this.orderDetail = {};
    this.allProductCounts = {};
    this.checkoutDetail('');
    // setTimeout(() => {
    this.cartAllProductCount('');
    // }, 1000);
    
    
    this.loaderService.isLoading.subscribe((res)=>{
      if(!res){
        this.checkIfAllDataLoaded = true;
      }
    })
   

    setTimeout(() => {
  payButton = document.getElementById("pay-button");
  let  form = document.getElementById("payment-form");

  setTimeout(function(){ 
    Frames.init(
      
      {
        publicKey: this.statePersist?.checkoutToken,
        style: {
          base: {
            color: 'black',
            fontSize: '18px',
          },
          autofill: {
            backgroundColor: 'yellow',
          },
          hover: {
            color: 'blue',
          },
          focus: {
            color: 'blue',
          },
          valid: {
            color: 'green',
          },
          invalid: {
            color: 'red',
          },
          placeholder: {
            base: {
              color: 'gray',
            },
            focus: {
              border: 'solid 1px blue',
            },
          },
        },
      }
      );

    Frames.addEventHandler(
      Frames.Events.CARD_VALIDATION_CHANGED,
      function (event) {

        payButton.setAttribute('disabled', String(!Frames.isCardValid()))
      }
    );

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      Frames.submitCard()
        .then(function (data) {
          Frames.addCardToken(form, data.token);
          (form as HTMLFormElement).submit();
        })
        .catch(function (error) {
          // handle error
        });
    });

 
   },500);
    }, 500);

 
  }

  ngAfterViewInit(){
    this.componentLoaded = true;
    
    this.mobileListCountStorageSubscribe = this.statePersist.watchmobileListCountStorage().subscribe(message => {
    
      if (!this.hasMobileCountAlreadyCall)
      {
        this.cartAllProductCount(message)
      }
    })

    this.checkoutDetailsApiSubscribe = this.statePersist.watchMyOrderDetail().subscribe(message => {
   
      if (!this.hasAlreadyCheckoutCall)
      {
        this.checkoutDetail(message)
      }
      
    })
  }
  isFirstOpen = false;
  isFirstOpen1 = true;

  ngOnDestroy(){
    if (this.mobileListCountStorageSubscribe){
      this.mobileListCountStorageSubscribe.unsubscribe()
    }

    if (this.checkoutDetailsApiSubscribe){
      this.checkoutDetailsApiSubscribe.unsubscribe()
    }
  
  }

  termsApplied(event){
    if (event.target.checked){
      document.getElementById('confirm-payment').removeAttribute("disabled")
    }
    else{
      document.getElementById('confirm-payment').setAttribute("disabled", 'true')
    }
  }
  backButtonRedirect(){
    let url = 'product/listing/All'
    this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_BACK_BUTTON_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_BACK_BUTTON_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
    this.router.navigate([url]);

  }

  redirectToReview(){
    this.googleAnalyticsService.eventEmitter(SharedConsts.BASKET_REVIEW_CLICK_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_REVIEW_CLICK_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate(['/mycart/review/']);
  }

  redirectTo(obj){
    let url;
    if (obj.hyperlink != ''){
      if (obj.search_value != ''){
        this.googleAnalyticsService.eventEmitter(SharedConsts.MYCART_PROMOTION_CLICK_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.BASKET_BACK_BUTTON_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
        this.statePersist.setLocalStorage('product_data', {'search_keyword':obj.search_value}, 'search')
        url = 'product/listing/All'
        this.router.navigate([url]);
      }
      else{
        url = obj.offer_url
        window.open(
          url, "_blank");
       }
    }
  }
  showMore(){
    this.show = !this.show;
  }
  checkoutDetail(msg){
    this.hasAlreadyCheckoutCall = true
    if (msg.includes('norefresh')){
      this.hasAlreadyCheckoutCall = false; 
      let newObj =  {"free_products":[],"promotions":[],"out_of_stock_message":"","items_count":"0","items_qty":"0","discount_description":"","min_cases":"","net_amount":"0.00","is_discount":"","one_free_withten_msg":[]}
      newObj['min_cases'] = this.orderDetail['min_cases']
      this.orderDetail = newObj
      this.promotionMessage = this.orderDetail.one_free_withten_msg
      this.show = false;
    }
    else{
      this.cartService.checkoutDetail()
    .subscribe(
      response => {
          if (response.status == 2212){
            this.alertService.error(response.response)
          }
          this.orderDetail = response.response
          this.promotionMessage = this.orderDetail.one_free_withten_msg
          this.show = false;
          if(this.orderDetail.items_count != '0' && this.orderDetail.min_cases == ''){
            this.firstHit = 1
          }
          if(response.response.cart_item_reload !=null && response.response.cart_item_reload == 'Yes'){
            this.statePersist.emitmyCartData('my cart list update')
          }
          else  if (msg.includes('mycart')){
            this.statePersist.emitmyCartData('my cart list update')
          }
          this.hasAlreadyCheckoutCall = false; 
        },
        error => { }
    )   
    } 
    
  }

  redirectToPayment(){
    this.bsModalRef.hide()
    this.router.navigate(['mycart/payment'])
  }

  placeOrder(card_payment, termsTemplate, before_payment, check_last_order, popup_24hr_template){

    if (!check_last_order){
      this.bsModalRef.hide();
    }
    this.submitted = true
    if(this.pOForm.invalid && this.orderDetail.is_po_enable){
      return
    }
    
    if(card_payment == 1){
      before_payment = 'before_payment'
    }
    
    let po_number;
    let flag, token, savecard;
    po_number = this.pOForm.controls.po_number.value.trim()
    this.cartService.placeOrder(this.firstHit, flag, token, savecard, before_payment, po_number, check_last_order)
    .subscribe(
      response => {
        
        if(this.global_data['payment_mode'] == 'Card'){
         
        this.statePersist.setLocalStorage('po_number', po_number)
        }
        if (response.status == 1161 || response.status ==1153 || response.status == 1157 || response.status == 2215){
          this.alertService.error(response.response)
        }
        else if (response.status == 403){
          this.router.navigate(['/'])
        }
        else if (response.status == 1180){
            localStorage.setItem('closeStorInfoMessage', response.response.msg)
            document.getElementById("openclosedStoreInfo").click();
        }
        else if (response.status == 1170){
          this.alertService.error(response.response.msg)
          this.statePersist.emitminiCartData('mini cart update')
          this.statePersist.emitoutOfStockData('out of stock update')
          this.statePersist.emitmobileListCountDetails('mobile count change')
          this.statePersist.emitmyCartData('my cart list update')
          this.statePersist.emitOrderDetailData('updae order Deatil')
        }
        else if (response.status == 1188) {
          this.popupMessage = response.response.split("<br>").join("\n");
          this.commonBottonText = "Confirm"
          this.popup(popup_24hr_template)
        }
        else{
          if(before_payment != '' && card_payment == 1){
            this.router.navigate(['mycart/payment'])
          }
          else{
            
            this.orderDetail['order_id'] = response.response.order_id
            this.orderDetail['order_date'] = response.response.order_date
            this.orderDetail['grand_total'] = response.response.grand_total
            this.orderDetail["transaction_payment_id"] = response.response.transaction_payment_id 
            this.orderDetail['transaction_date'] = response.response.transaction_date
            this.orderDetail['price_visibility'] = this.global_data['price_visibility']
            this.orderDetail['card_payment'] = card_payment
            this.statePersist.setLocalStorage('order-detail', this.orderDetail)
            this.statePersist.emitminiCartData('mini cart update')
            this.googleAnalyticsService.eventEmitter(SharedConsts.PLACE_ORDER_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.PLACE_ORDER_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
            this.router.navigate(['mycart/order-confirmation'])
          }
          
        }
        this.firstHit = ''
        },
        error => { }
    )

    

  }

  cartAllProductCount(msg){
    this.hasMobileCountAlreadyCall = true
    if (msg.includes('norefresh')){
      this.allProductCounts = {}
      this.hasAlreadyCheckoutCall = false; 
    }
    else{
      this.cartService.cartAllProductCount()
      .subscribe(
        data => {
          if (data.response) {
            if (data.status == 2212){
              this.alertService.error(data.response)
            }
            this.allProductCounts = data.response;
          }
          this.hasMobileCountAlreadyCall = false;
          }

      )
    }
    
  }

}